import { toast } from 'react-toastify';
import {ICartItem} from '../../domain/models/ICart';
import i18n from "i18n";

  export const AddCartItemByIdUseCase = (
    prevCartItems: ICartItem[],
    cartItemId: string,
    quantity: number,
  ): ICartItem[] => {
    const addCartItem = (
      _prevCartItems: ICartItem[],
      _cartItemId: string,
      _quantity: number,
    ) => {
      const newCartItems = _prevCartItems.map(prevCartItem => {
        if (prevCartItem.id === _cartItemId) {
          if (prevCartItem?.maxQuantityPerUser && (prevCartItem.quantity + _quantity) > prevCartItem.maxQuantityPerUser) {
            toast.error(
              i18n.t("order.errors.max_quantity_per_user", {
                quantity: prevCartItem.maxQuantityPerUser
              })
            );
            return {...prevCartItem};
          }
          return {...prevCartItem, quantity: prevCartItem.quantity + _quantity};
        } else {
          return {...prevCartItem};
        }
      });
      return newCartItems;
    };
  
    return addCartItem(prevCartItems, cartItemId, quantity);
  };

